import { SMALL_MODAL } from 'consts/modalStyles'
import type { TDatadogErrorLog } from 'utils/datadog/types'

export const MODAL_STYLE = {
  ...SMALL_MODAL,
  content: {
    ...SMALL_MODAL.content,
    padding: '32px',
  },
}

export const CREATE_TERRITORY_ANALYSIS_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/modules/niche/create-niche-dashboard-modal/index.ts',
  name: 'Creates a Territory Analysis Dashboard',
  message: 'Failed to create a dashboard from the niche context',
}
